import React, { useRef, useEffect } from 'react'
import { withNamespaces } from 'react-i18next';
import lottie from 'lottie-web'
import { Link } from 'react-router-dom';

//style
import * as styles from './index.styles'

//image
import IcArrowRightBlue from '../../../assets/images/IcArrowRightBlue/IcArrowRightBlue';

//constant
import { COMMUNICATION } from '../../../assets/constant/pathNames';


const PageFour = ({ t }) => {

    const wrapAnimation = useRef()

    useEffect(() => {
        lottie.loadAnimation({
            container: wrapAnimation.current,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: '/animation/page_four.json'
        })
    }, []);

    return (
        <styles.Bound>
            <div className="content-text">
                <div className="title-page">
                    <p>{t('home.page_four.text_1')}</p>
                    <p className="title-page blue">{t('home.page_four.text_2')}</p>
                </div>
                <p className="des-page">{t('home.page_four.text_3')}</p>
                <div className="content-page">
                    {t('home.page_four.text_4')}
                </div>
                <Link className="tutorial" to={`/${COMMUNICATION}`}>
                    <p>{t('home.page_four.text_5')}</p>
                    <IcArrowRightBlue />
                </Link>
            </div>
            <div className="lottie-wrap">
                <div className="lottie" ref={wrapAnimation}></div>
            </div>
        </styles.Bound >
    )
}

export default withNamespaces()(PageFour)
